
<div id="main-wrapper">
        <!-- ============================================================== -->
             <!-- Page wrapper  -->
             <!-- ============================================================== -->
             <app-header></app-header>
             <app-sidebar ></app-sidebar>
             <div class="page-wrapper">
               <!-- ============================================================== -->
               <!-- Container fluid  -->
               <!-- ============================================================== -->
               <div class="container-fluid">
              
                <app-topbar></app-topbar>
                      <!-- ============================================================== -->
                     <!-- Start Page Content -->
                     <!-- ============================================================== -->
                   
                                     <router-outlet></router-outlet>
                              
                     <!-- ============================================================== -->
                     <!-- End PAge Content -->
                     <!-- ============================================================== -->
     
                 </div>
               </div>
     
     </div>